export default __webpack_public_path__ + "static/media/logo-black.25bcf29b.png";